import heroImage from "../assets/hero-health.png";
import bed from "../assets/bed2.jpeg";


const products = [

    {
        id: 1,
        name: "Standard Wheelchair",
        price: "450000",
        image: bed,
        category: "Wheelchairs",
        shortDescription: "Comfortable and durable wheelchair designed for everyday mobility.",
        description: "The Standard Wheelchair is built with a lightweight steel frame, comfortable seating, durable wheels, and foldable construction for easy transport and storage.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },

    {
        id: 2,
        name: "Electric Hospital Bed",
        price: "1200000",
        image: heroImage,
        category: "Hospital Beds",
        shortDescription: "Comfortable and durable hospital bed designed for patient care.",
        description: "The Electric Hospital Bed is equipped with advanced features for patient comfort and care, including adjustable height, backrest, and leg support.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"       
    },

    {
        id: 3,
        name: "Walking Walker",
        price: "120000",
        image: heroImage,
        category: "Walking Aids",
        shortDescription: "Sturdy and reliable walking aid for improved mobility and balance.",
        description: "The Walking Walker is designed to provide stability and support for individuals with mobility challenges, featuring a wide base and adjustable height.",      
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },

    {
        id: 4,
        name: "Digital Blood Pressure Monitor",
        price: "80000",
        image: heroImage,
        category: "Diagnostic Equipment",
        shortDescription: "Accurate and reliable blood pressure monitoring device.",
        description: "The Digital Blood Pressure Monitor provides precise readings with an easy-to-use interface, making it ideal for home and clinical use.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },
    {
        id: 5,
        name: "Standard Wheelchair",
        price: "450000",
        image: bed,
        category: "Wheelchairs",
        shortDescription: "Comfortable and durable wheelchair designed for everyday mobility.",
        description: "The Standard Wheelchair is built with a lightweight steel frame, comfortable seating, durable wheels, and foldable construction for easy transport and storage.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },

    {
        id: 6,
        name: "Electric Hospital Bed",
        price: "1200000",
        image: heroImage,
        category: "Hospital Beds",
        shortDescription: "Comfortable and durable hospital bed designed for patient care.",
        description: "The Electric Hospital Bed is equipped with advanced features for patient comfort and care, including adjustable height, backrest, and leg support.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },

    {
        id: 7,
        name: "Walking Walker",
        price: "120000",
        image: heroImage,
        category: "Walking Aids",
        shortDescription: "Sturdy and reliable walking aid for improved mobility and balance.",
        description: "The Walking Walker is designed to provide stability and support for individuals with mobility challenges, featuring a wide base and adjustable height.",      
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    },

    {
        id: 8,
        name: "Digital Blood Pressure Monitor",
        price: "80000",
        image: heroImage,
        category: "Diagnostic Equipment",
        shortDescription: "Accurate and reliable blood pressure monitoring device.",
        description: "The Digital Blood Pressure Monitor provides precise readings with an easy-to-use interface, making it ideal for home and clinical use.",
        specifications: {
            Frame: "Steel",
            Weight: "18 kg",
            Capacity: "120 kg",
            Foldable: "Yes",
            Warranty: "12 Months"
        },
        stock: "In Stock"
    }

];


export default products;